import { makeStyles } from '@material-ui/core/styles';

// components
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/shared/Typography';
import Input from 'components/shared/Input';

// constants
import { SPACING_THIRD } from 'constants/spacing';
import { useHistory } from 'react-router-dom';
import LoadingButton from 'components/shared/LoadingButton';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    width: '100%',
  },
}));

/**
 * @component ForgetPassword
 */
function ForgetPassword() {
  const classes = useStyles();

  const history = useHistory();
  const onSubmit = (e) => {
    e.preventDefault();
    history.push('/');
  };
  return (
    <Container maxWidth="sm">
      <div className={classes.root}>
        <form noValidate onSubmit={onSubmit} className={classes.form}>
          <Grid container spacing={SPACING_THIRD} justifyContent="center">
            <Grid item xs={12}>
              <Typography gutterBottom>لطفا شماره تلفن همراه خود را وارد کنید</Typography>
            </Grid>
            <Grid item xs={12}>
              <Input
                label="شماره همراه"
                type="tel"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <LoadingButton
                type="submit"
                size="small"
                variant="contained"
                color="primary"
                fullWidth
              >
                ارسال کد
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  );
}

export default ForgetPassword;
